var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFb = function SvgFb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_815_7030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.594 0C81.445 0 0 81.445 0 18.594V817.407C0 918.556 81.445 1000 182.594 1000H526.657V609.063H423.282V468.313H526.657V348.063C526.657 253.588 587.736 166.844 728.438 166.844C785.406 166.844 827.532 172.313 827.532 172.313L824.219 303.751C824.219 303.751 781.256 303.345 734.375 303.345C683.636 303.345 675.5 326.723 675.5 365.533V468.314H828.25L821.594 609.064H675.5V1000H817.406C918.555 1000 1000 918.557 1000 817.408V182.595C1000 81.446 918.555 0.001 817.406 0.001H182.593L182.594 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_815_7030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
};
export default SvgFb;